import { BehaviorSubject } from 'rxjs';

export default class CreatorRepository {
  creators$ = new BehaviorSubject([]);
  creatorToInvite$ = new BehaviorSubject(null);
  searchCriteria$ = new BehaviorSubject(null);

  constructor({ creatorService }) {
    this.creatorService = creatorService;
  }

  async inviteCreator(name, telephone, email, isTrainee) {
    await this.creatorService.inviteCreator(name, telephone, email, isTrainee);
  }

  async resendInvite(name, phoneNumber, email, id) {
    return this.creatorService.resendInvite(name, phoneNumber, email, id);
  }

  async getCreators(criteria) {
    const creators = await this.creatorService.getCreators(criteria);
    this.creators$.next(creators);
  }
}
